import React from 'react';
import ApplicationViews from './ApplicationViews'
import './App.css';

function App() {
  return (<> <ApplicationViews /> </>);
}

export default App;